import { SolitaireListener } from '../game/solitaire-listener';
import { RemoteRoundParams, RoundParams } from 'src/games/common/phaser/model/round-params';
import { RemoteRoundResultSubmitter } from 'src/games/common/phaser/model/remote-round-result-submitter';
import { RemoteDealer } from 'src/games/common/phaser/model/remote-dealer';
import { CardId } from '../logic/card/card-id';

export class SolitaireRemoteRoundParams extends RemoteRoundParams {
  constructor(
    readonly dealer: RemoteDealer<string>,
    remoteRoundResultSubmitter: RemoteRoundResultSubmitter,
    readonly logicVersion: number,
  ) {
    super(remoteRoundResultSubmitter);
    this.dealer = dealer;
  }

  public static create(
    solitaireListener: SolitaireListener,
    logicVersion: number,
  ): SolitaireRemoteRoundParams {
    const dealer = new RemoteDealer<string>(
      solitaireListener,
      (secret) => new CardId(secret.value).id,
    );

    return new SolitaireRemoteRoundParams(
      dealer,
      new RemoteRoundResultSubmitter(solitaireListener),
      logicVersion,
    );
  }

  public static isRound(roundParams: RoundParams): roundParams is SolitaireRemoteRoundParams {
    return roundParams instanceof SolitaireRemoteRoundParams;
  }
}
